// extracted by mini-css-extract-plugin
export default {"CommentBox":"CommentBox_CommentBox__N7MTn","ReplyBox":"CommentBox_ReplyBox__lkR-U"};